import { Input } from '@any-ui-react/core';
import classNames from 'classnames';
import { cloneElement, useState } from 'react';

import { MaterialIcons } from '@/common/components/shared/material-icons';

interface Props {
  value: number;
  disabled?: boolean;
  error?: string;
  readonly?: boolean;
  size?: 'default' | 'sm';
  withBorder?: boolean;
  withDescription?: boolean;
  onClick: (value: number) => void;
}

export const StarRating = ({
  value = 0,
  disabled,
  error,
  readonly,
  size = 'default',
  withBorder = true,
  withDescription = true,
  onClick,
}: Props) => {
  const element = <MaterialIcons iconName={size === 'default' ? 'star' : 'star_rate'} fill={true} fontSize="24px" />;
  const [hovered, setHovered] = useState(0);

  return (
    <div className="flex flex-col space-y-1">
      <div
        className={classNames('flex justify-center', {
          'bg-gray-0': readonly || disabled,
          'rounded border px-2 py-6 lg:px-8': withBorder,
          'rounded border p-1': size === 'sm',
          'border-failure': error,
        })}
      >
        <div className="flex w-full items-center justify-center space-x-11">
          {withDescription && <span className="text-center">Needs Improvement</span>}
          <div
            className={classNames('flex space-x-4', {
              'xl:space-x-20': size === 'default',
            })}
          >
            {[1, 2, 3, 4, 5].map((_, index) =>
              cloneElement(element, {
                key: index,
                onMouseEnter: readonly || disabled ? undefined : () => setHovered(index + 1),
                onMouseLeave: readonly || disabled ? undefined : () => setHovered(0),
                onClick: readonly || disabled ? undefined : () => onClick(index + 1),
                className: classNames({
                  'text-warning/40': index < hovered && index >= value,
                  'text-warning': index < (hovered || value),
                  'text-gray-2': index >= (hovered || value),
                  'cursor-pointer': !readonly && !disabled,
                }),
              }),
            )}
          </div>
          {withDescription && <span>Outstanding</span>}
        </div>
      </div>
      {error && <Input.Error className="text-failure">{error}</Input.Error>}
    </div>
  );
};
